import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useContext } from 'react'
import cx from 'classnames'
import { redo } from 'prosemirror-history'

import { ReactComponent as RedoIcon } from 'assets/icons/redoIconOnly24.svg'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { Button } from 'components/Button'
import { AlmanacEditorStateContext } from 'stores/EditorState'

import Styles from '../MobileToolbar.module.scss'

interface Props {
  className?: string
}

export const RedoButton = observer(function RedoButton({ className }: Props) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!
  const view = useEditorView()

  const redoDisabled = computed(() => !almanacState.redoDepth).get()

  const handleRedo = () => {
    if (!redoDisabled) redo(view.state, view.dispatch)
    view.focus()
  }

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      className={cx(Styles.button, {
        [Styles.disabled]: redoDisabled,
      })}
      onClick={handleRedo}
      aria-label="Redo button"
    >
      <RedoIcon />
    </Button>
  )
})
